import api from '../../../services/api';React
import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import {CardContent,  FormGroup, TextField, FormControl, FormHelperText, FormLabel, RadioGroup, Radio } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { Switch, FormControlLabel } from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import AlertInformation from '../../../components/AlertInformation/AlertInformation';

class HistoricoBancarioForm extends Component {  
  constructor(props) {
    super(props);
    this.state = {
      historicobancario: {},
      isNewRecord : false,
      isView : false,
      schema : {
        usuario: {
          presence: { allowEmpty: false, message: 'é obrigatório' },
          length: {
            maximum: 64
          }
        },
      },
      
      useStyles : makeStyles(theme => ({
        root: {
          backgroundColor: theme.palette.background.default,
          height: '100%'
        },
        grid: {          
          height: '100%'
        },
        quoteContainer: {
          [theme.breakpoints.down('md')]: {
            display: 'none'
          }
        },
        quote: {
          backgroundColor:  theme.palette.neutral,
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundImage: 'url(/images/auth.jpg)',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'
        },
        quoteInner: {
          textAlign: 'center',
          flexBasis: '600px'
        },
        quoteText: {
          color: theme.palette.white,
          fontWeight: 300
        },
        name: {
          marginTop: theme.spacing(3),
          color: theme.palette.white
        },
        bio: {
          color: theme.palette.white
        },
        contentContainer: {},
        content: {
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        },
        contentHeader: {
          display: 'flex',
          alignItems: 'center',
          paddingTop: theme.spacing(5),
          paddingBototm: theme.spacing(2),
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2)
        },
        logoImage: {
          marginLeft: theme.spacing(4)
        },
        contentBody: {
          flexGrow: 1,
          display: 'flex',
          alignItems: 'center',
          [theme.breakpoints.down('md')]: {
            justifyContent: 'center'
          }
        },
        form: {
          paddingLeft: 100,
          paddingRight: 100,
          paddingBottom: 125,
          flexBasis: 700,
          [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2)
          }
        },
        title: {
          marginTop: theme.spacing(3)
        },
        socialButtons: {
          marginTop: theme.spacing(3)
        },
        socialIcon: {
          marginRight: theme.spacing(1)
        },
        sugestion: {
          marginTop: theme.spacing(2)
        },
        textField: {
          marginTop: theme.spacing(2)
        },
        signInButton: {
          margin: theme.spacing(2, 0)
        },
        alert: {
          color: '#000000',
        }
      })),
    };
  }

  async componentDidMount(){
    // busca dados configurações
    let aExportaLayoutA2x = sessionStorage.getItem('exportaLayoutA2x');
    if ((aExportaLayoutA2x == null) || (aExportaLayoutA2x == undefined)) {      
      let codEmpresa = sessionStorage.getItem('codEmpresa');
      if((codEmpresa === null) || (codEmpresa === undefined)){
        codEmpresa = 1;
      }

      const field = '?field=EXPORTALAYOUTA2X';
      const aURL = '/financas/configuracoes/' + codEmpresa + field;
      const response = await api.get(aURL)                             
      .then(function (response) {
        sessionStorage.setItem('exportaLayoutA2x', response.data[0].exportalayouta2x);
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
    }
    
    // carrega informações formulário
    const { id } = this.props.match.params;
    const { location } = this.props;
    const currentPath = location.pathname;    
    
    if (id >= 0) {
      const response = await api.get(`/historico/${id}`);
      
      this.setState({ historicobancario: response.data[0],
        isNewRecord : false,
        isView : (currentPath.includes('/view'))}
      );      
      
    }    
    else
    if ( id === 'novo') 
    {
      this.setState({ 
        isNewRecord : true
      });
      this.state.isNewRecord = true;
      const { historicobancario } = this.state;
    }
  }
  
  // Change histórico bancário
  OnChange = (event) => {  
    const { historicobancario } = this.state;
    const input = event.target;
    let value = input.value.toUpperCase();   
    historicobancario[event.target.name] = value;

    if (input.name === 'inativo') {
      value = input.checked;
      if (value === false){
        historicobancario.inativo = ASIM;
      }
      else
      {
        historicobancario.inativo = ANAO;
      }
    }

    if (input.name === 'indicadc') {
        historicobancario.indicadc = event.target.value;
    }

    this.setState({ historicobancario: historicobancario });   
  };

  /* atualiza dados de histórico bancário existente - post */
  atualizaHistoricoBancario = async () =>{
    const { historicobancario } = this.state;

    historicobancario.descricao = historicobancario.descricao.trim();    

    if (historicobancario.codhistoricoexp) 
    historicobancario.codhistoricoexp = historicobancario.codhistoricoexp.trim();
    
    if (historicobancario.codhistoricoexp == null)
    historicobancario.codhistoricoexp = '';

    try {
      const response = await api.post(`/historico/${historicobancario.codigo}`, historicobancario);
      if (response.status === 200) {
        this.props.history.push('/financas/historicosbancarios');
      }
    } catch (error) {
      this.handleOpenAlert(error.response.data.error);
    }
  }

  /* abre janela de alerta com mensagem */
  handleOpenAlert = (message) => {
    this.setState({ openAlert: true });
    this.setState({ messageAlert: message});
  };

  /* fecha janela mensagem alerta */
  handleCloseAlert = () => {
    this.setState({ openAlert: false });
  }

  /* Click salvar */
  onClickSave = () =>{
    if (this.validationRequiredFields()){
      if (this.state.isNewRecord){
        this.insereHistoricoBancario()
      }
      else
      {
       this.atualizaHistoricoBancario();
     }
    }
  }

  /* Click cancelar */
  onClickCancel = () =>{
    this.props.history.push('/financas/historicosbancarios');
  }


  /* verifica se tem erro campos atendimento */
  hasErrorField = (field, value) => {
    if (field === 'descricao') {
      if ((String(value).trim() === ''))
      {
        return true
      }
    }
  }

  /* valida campos obrigatórios ao salvar */
  validationRequiredFields() {
    const { historicobancario } = this.state

    if( (String(historicobancario.descricao).trim() === '')  || (historicobancario.descricao === undefined)){
        historicobancario.descricao = '';
      this.setState({historicobancario: historicobancario });
      return false
    } else 
    if( (String(historicobancario.indicadc).trim() === '')  || (historicobancario.indicadc === undefined)){
        historicobancario.indicadc = '';
      this.setState({historicobancario: historicobancario });
      return false
    } else 
    {
      return true
    }  
  }

  /* insere novo histórico bancário */
  insereHistoricoBancario = async () =>{
    const { historicobancario } = this.state;
    historicobancario.codusuarioregistrou = parseInt(sessionStorage.getItem('codUser'));
    
    historicobancario.descricao = historicobancario.descricao.trim();
    if (historicobancario.codhistoricoexp) {
        historicobancario.codhistoricoexp = historicobancario.codhistoricoexp.trim(); 
    }
    
    try {
      const response = await api.post(`/historico`, historicobancario);
      if (response.status === 200) {
        this.props.history.push('/financas/historicosbancarios');
      }
    } catch (error) {
      // console.log(error);
      // console.log(error.message);
      this.handleOpenAlert(error.response.data.error);
    }
  }

  render() {
    const { historicobancario } = this.state;
    return (
      <div>
        <CardContent>
          <Typography 
            component="h1"
            variant="h3"
          >
            Histórico Bancário {historicobancario.codigo} 
          </Typography>             
          
          <FormGroup>
            <TextField
              className={this.state.useStyles.textField}
              label="Nome do histórico bancário"
              style={{ marginTop: '10px' }} 
              name="descricao"
              value = {historicobancario.descricao || ''}
              variant="outlined"
              onChange={this.OnChange}
              helperText={historicobancario.descricao === '' ? 'Nome do histórico bancário obrigatório' : ' '}
              disabled={this.state.isView}
              inputProps={{ maxLength: 30 }}
            />
          </FormGroup> 

          <FormControlLabel
            control={
              <Switch
                checked={!(historicobancario.inativo === ASIM)}
                name="inativo"
                onChange={this.OnChange}
                color="primary"
                disabled={this.state.isView}
              />
            }
            label={(historicobancario.inativo === ASIM) ? 'Inativo' : 'Ativo'}
          />
          
          <br />
          <br />

          <FormControl disabled={this.state.isView}>
            <FormLabel>Tipo Operação</FormLabel>
            <RadioGroup
                row
                name="indicadc"
                value = {historicobancario.indicadc || ''}                
                onChange={this.OnChange}                
            >
                <FormControlLabel value="C" control={<Radio />} label="Crédito" />
                <FormControlLabel value="D" control={<Radio />} label="Débito" />
            </RadioGroup>
            <FormHelperText>{historicobancario.indicadc === '' ? 'Tipo de operação obrigatório' : ' '}</FormHelperText>
          </FormControl>

          <br />
          <br />
  
          <FormGroup style={{ display: (sessionStorage.getItem('exportaLayoutA2x') == ASIM ? '' : 'none' ) }} >
            <TextField
              className={this.state.useStyles.textField}
              label="Código para exportação"
              style={{ width: 200, marginRight: '10px' }}
              name="codhistoricoexp"
              value ={historicobancario.codhistoricoexp || ''}
              variant="outlined"
              onChange={this.OnChange}          
              disabled={this.state.isView}
              inputProps={{ maxLength: 50 }}
            />
          </FormGroup>
        
          <br/>

          <Button
            name="salvar"
            color="primary"
            variant="contained"
            onClick={this.onClickSave}
            style={{ marginTop: '10px' }} 
            disabled={this.state.isView}
          >
            Salvar
          </Button>

          <Button
            name="cancelar"
            color="primary"
            variant="contained"
            onClick={this.onClickCancel}
            style={{ marginTop: '10px', marginLeft: '10px' }}
          >
            Cancelar
          </Button>
        </CardContent>

        <AlertInformation
          open={this.state.openAlert}
          handleClose={() => this.handleCloseAlert()}
          message={this.state.messageAlert}
        />
      </div>
    );
  }
}

HistoricoBancarioForm.propTypes = 
{
  classes: PropTypes.object.isRequired
};

export default HistoricoBancarioForm;